import React, { FC } from 'react';
import { GenericIcon } from './GenericIcon';
import { IconProps } from './types';

export const createIconProd = (path: string): FC<IconProps> => (props) => <GenericIcon path={path} {...props} />;
